import ETC_AXIOS from './etc.axios'
// util
import Util from '@/utils/util'
import APP from '../config/app.config'
import ETC from '../config/etc.config'
import ETCUtil from '@/utils/util.etc'

// 重构新接口
export default {
  // 重构版本获取用户当前订单状态
  getGrayTestIsNew(data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/gray-test/is-new', data)
  },
  // 重构版本获取用户当前订单状态

  getApplyCurrentOrder(data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/current-order', data)
  },
  // 获取商品信息
  getApplyGoodsDetail (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/no-login/goods-detail', {coord_type: 1, ...data}).then(res => {
      return res
    })
  },
  // 发送验证码
  sendVerificationCode (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/send-verification-code', data)
  },
  // 发送验证码(新图形验证码版本)
  sendVerificationCodeNew (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/send-verify-code', data)
  },
  // 获取图形验证码
  getImgCheckCode (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/verification-code/get-verification-code', data)
  },
  // 发送车牌号
  postApplySubmitPlate (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/submit-plate', data)
  },
  // 发送车牌号
  userSaveAddress (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/user/save-address', data)
  },
  // 创建订单
  orderSubmitOrder (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/order/submit-order', data)
  },
  applyGetProductList (data) {
    data.source = ETC.APP_CHANNEL_PL[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)] || ''
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/get-product-package-list', data)
  },
  // 支付
  applyPurchase (data) {
    data.source = ETC.APP_CHANNEL_PL[localStorage.getItem(ETC.LOCAL_STORAGE_KEY.APP_FROM_CHANNEL)] || ''
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/purchase', data)
  },
  // 签约免密
  entrustSignContract (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/entrust/sign-contract', data)
  },
  // 不确定是否签约调用签约免密
  entrustQuery (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/entrust/query', data)
  },
  orderSubmitReviewOrder (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/order/submit-review-order', data)
  },
  userUploadImage (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/user/upload-image', data)
  },
  // 上传图片到cos
  userUploadImageToCos (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/user/upload-image-to-cos', data, {headers: {'Content-Type': 'multipart/form-data', timeout: 60000}})
  },
  // 获取上次识别信息
  userGetDraft (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/user/get-draft', data).then(res => {
      res = ETCUtil.carInfoDataFormat(res)
      const result = Util.deepAssign(res.ocr_result, {idcard_back: {}, idcard_front: {}, vehicle_front: {}, vehicle_back: {}})
      let idCard = Object.assign({}, result.idcard_front, result.idcard_back)
      if (idCard.number) {
        idCard.number = idCard.number.replace(/(\S{14})(\S+)/g, '$1 $2').replace(/(\S{6})(\S+)/g, '$1 $2')
      }
      // 对上次结果进行返显处理
      let vehicle = Object.assign({}, result.vehicle_back, result.vehicle_front)
      vehicle.plate_no = (result.vehicle_front.plate_no || result.vehicle_back.plate_no || '').toUpperCase()
      // if (res.address && res.address.send_phone) {
      //   res.address.send_phone = res.address.send_phone.replace(/ /g, '').replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3')
      // }
      let images = {
        idcard_front: {status: '', url: res.img_url.idCard.idcard_front},
        idcard_back: {status: '', url: res.img_url.idCard.idcard_back},
        idcard_hold: {status: '', url: res.img_url.idCard.idcard_hold},
        vehicle_front: {status: '', url: res.img_url.license.vehicle_front},
        vehicle_back: {status: '', url: res.img_url.license.vehicle_back},
        vehicle_car: {status: '', url: res.img_url.license.vehicle_car}
      }
      // 通过有效时间判断上次是否为高并发状态
      images.idcard_front.status = images.idcard_front.url ? (res.ocr_success.idcard_front ? 2 : 4) : 0
      images.idcard_back.status = images.idcard_back.url ? (res.ocr_success.idcard_back ? 2 : 4) : 0
      images.idcard_hold.status = images.idcard_hold.url ? 2 : 0
      images.vehicle_front.status = images.vehicle_front.url ? (res.ocr_success.vehicle_front ? 2 : 4) : 0
      images.vehicle_back.status = images.vehicle_back.url ? (res.ocr_success.vehicle_back ? 2 : 4) : 0
      images.vehicle_car.status = images.vehicle_car.url ? 2 : 0
      if (Util.isNull(idCard)) return {validate_result: res.validate_result, draft_sn: res.draft_sn}
      return {idCard, vehicle, address: res.address, images: images, validate_result: res.validate_result, draft_sn: res.draft_sn}
    })
  },
  userUpdateDraftIdCard (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/user/update-draft-id-card', data)
  },
  userUpdateDraftVehicle (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/user/update-draft-vehicle', data)
  },
  applyCancelOrder (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/cancel-order', data)
  },
  orderGetCancelOrder (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/order/get-cancel-order', data)
  },
  cancelStatusConfirm (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply/cancel-result-confirm', data)
  },
  orderDeclareReceived (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/order/declare-received', data)
  },
  orderExpressTrace (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/order/express-trace', data)
  },
  // 货车提交信息
  truckSubmitApplyInfo (data) {
    return ETC_AXIOS.post(APP.HTTP_APPLY_URL + '/apply-info/submit-apply-info', data)
  }
}
